import { render, staticRenderFns } from "./VectricAdminTool.vue?vue&type=template&id=38542ba2&scoped=true&"
import script from "./VectricAdminTool.vue?vue&type=script&lang=js&"
export * from "./VectricAdminTool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38542ba2",
  null
  
)

export default component.exports